define('v3/Pages/Home/ViewModels/GroupPupilsToSubject.ViewModel',[
	'knockout',
	'lodash',
	'v3/Common/Helpers/Sort/Sort.Helper',
	'v3/Common/Models/enums',
	'v3/Common/Models/Pupils.Model',
	'v3/Pages/Home/Services/SubjectGroup.Backend',
	'v3/Common/Services/pageStateService'
], function (ko, _, SortableHelper, enums, PupilsModel, subjectGroupBackend, pageStateSrv) {
	function GroupPupilsModel (pupils, selectedIds) {
		var self = this;
		if (pupils.length < 1) throw new Error('Cannot create GroupPupilsModel without pupils');

		self.enums = enums;
		self.title = ko.observable(pupils[0].actualClassName);
		self.sortKey = ko.observable(SortableHelper.prototype.settingsSortingKey());
		self.sortDirection = ko.observable(enums.sortDirection.ascending);

		self.pupils = ko.observableArray(_.map(pupils,
			function (p) {
				p.id = p.userId;
				p.firstName = p.firstNameForSorting;
				p.lastName = p.lastNameForSorting;
				p.firstNameForSorting = p.firstNameForSorting && p.firstNameForSorting.trim();
				p.lastNameForSorting = p.lastNameForSorting && p.lastNameForSorting.trim();
				return new PupilsModel(p, selectedIds);
			}));

		self.currentSortSetting = ko.observable({
			key: self.sortKey(),
			direction: enums.sortDirection.ascending
		});

		self.currentSortSetting.subscribe(function (sortSetting) {
			self.sortKey(sortSetting.key);
			self.sortDirection(sortSetting.direction);
		});

		self.sortedPupils = new SortableHelper(self.sortKey, self.sortDirection, self.pupils);

		self.allPupilsSelected = ko.computed({
			read: function () {
				var allOn = _.every(self.pupils(), function (p) { return p.isSelected(); });
				var allOff = _.every(self.pupils(), function (p) { return !p.isSelected(); });
				if (allOn) return true;
				if (allOff) return false;
				return null;
			},
			write: function (val) {
				_.each(self.pupils(), function (pupil) {
					pupil.isSelected(val);
				});
			}
		});

		self.expanded = ko.observable(true);
		self.pupilCount = ko.computed(function () {
			var pupils = self.pupils();
			var selectedPupils = _.filter(pupils, function (p) { return p.isSelected(); });
			return selectedPupils.length + '/' + pupils.length;
		});

		return self;
	}

	function GroupPupilsViewModel () {
		var self = this;

		self.subjectGroupId = pageStateSrv.getNumberObservable('subjectGroupId');
		self.groupName = ko.observable('');

		self.pupilsGroupsContainers = ko.observableArray();
		self.selectedIds = ko.observableArray([]).extend({ rateLimit: 0 });

		subjectGroupBackend.getAllAvailablePupils()
			.then(function (pupils) {
				var myPupils = _.filter(pupils, function (p) { return p.pupilFromAnotherClass === false; });
				if (myPupils.length > 0) {
					var firstClass = new GroupPupilsModel(myPupils, self.selectedIds);
					self.pupilsGroupsContainers.push(firstClass);
				}

				var otherPupils = _.filter(pupils, function (p) { return p.pupilFromAnotherClass === true; });
				var classes = _.groupBy(otherPupils, 'actualClassName');
				_.each(_.keys(classes), function (cl) {
					if (classes[cl].length > 0) {
						var nextClass = new GroupPupilsModel(classes[cl], self.selectedIds);
						nextClass.expanded(false);
						self.pupilsGroupsContainers.push(nextClass);
					}
				});
			});

		subjectGroupBackend.getGroupDetailsPupilIds(self.subjectGroupId())
			.then(function (model) {
				self.groupName(model.groupName);
				self.selectedIds(model.pupilIds);
			});

		self.saveGroupName = function (groupName) {
			subjectGroupBackend.saveGroupName(self.subjectGroupId(), groupName);
		};

		self.saveGroup = function () {
			subjectGroupBackend.savePupilIdsInGroup(self.subjectGroupId(), self.groupName(), self.selectedIds())
				.then(function () {
					subjectGroupBackend.getRedirectToTeachV4Url(self.subjectGroupId())
						.then(function (url) {
							window.location.href = url;
						});
				});
		};

		self.onClose = function () {
			subjectGroupBackend.getRedirectToTeachV4Url(self.subjectGroupId())
				.then(function (url) {
					window.location.href = url;
				});
		};
	}

	return GroupPupilsViewModel;
});
